// extracted by mini-css-extract-plugin
module.exports = {"projects":"FeaturedProjects_projects__p5rwD","projectsMobile":"FeaturedProjects_projectsMobile__BRIoW"};